import { render, staticRenderFns } from "./ToolPageCta.vue?vue&type=template&id=06f1d38e&scoped=true&"
import script from "./ToolPageCta.vue?vue&type=script&lang=ts&"
export * from "./ToolPageCta.vue?vue&type=script&lang=ts&"
import style0 from "./ToolPageCta.vue?vue&type=style&index=0&id=06f1d38e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f1d38e",
  null
  
)

export default component.exports